import { Store } from 'vuex'

export const Loading = (loader = 'global-loader'): MethodDecorator => {
  return (target, methodName: string | symbol) => {
    // Get the vuex module
    const module = target.constructor as any

    // Save the original action function
    const actionFunction = module.actions[methodName]

    // And proxy the action
    module.actions[methodName] = (store: Store<any>, ...args: any[]) => {
      // Start the loader
      store.commit('wait/START', loader)

      // Call the action
      let returnValue: any

      try {
        returnValue = actionFunction(store, ...args)
      } catch (e) {
        store.commit('wait/END', loader)

        throw e
      }

      // And finish the loader after the action has finished
      if (returnValue.then) {
        return returnValue
          .then((response: any) => {
            store.commit('wait/END', loader)

            return response
          })
          .catch((e: any) => {
            store.commit('wait/END', loader)

            throw e
          })
      } else {
        store.commit('wait/END', loader)

        return returnValue
      }
    }
  }
}
